<template>
    <div>
        <!-- Company -->
        <div class="form-group">
            <label class="control-label">Company</label>
            <company name="Domain" :errorName="model.errorName" v-model="model.company" :min-length="0"></company>
        </div>

        <!-- Registrar -->
        <registrar v-model="model.registrar_id"></registrar>

        <!-- Domain Basics -->
        <domain-fields v-model="model"></domain-fields>

        <!-- Messages -->
        <span v-if="processing" class="popup-alert alert-info"><i class="icon icon-spinner fa-spin"></i> Checking Availability</span>
        <span v-else-if="query === 'success'" class="popup-alert alert-success">{{ trans('domain_available') }}</span>
        <span v-else-if="query === 'registered'" class="popup-alert alert-info"><i class="icon icon-spinner fa-spin"></i> {{ trans('domain_registered') }}</span>
        <span v-else-if="query === 'hosted_tppwholesale'" class="popup-alert alert-success">This domain is managed under our TPP Wholesale account.</span>
        <span v-else-if="query === 'hosted_synergywholesale'" class="popup-alert alert-success">This domain is managed under our Synergy Wholesale account.</span>
        <span v-else-if="query === 'error'" class="popup-alert alert-danger">{{ trans('domain_unavailable') }}</span>
        <span class="popup-alert" v-else>&nbsp;<!-- awaiting input --></span>

        <!-- Actions -->
        <div class="row">
            <div class="col-lg-12 section">
               <!-- <button @click="available" class="panelSubmit btn btn-success btn-sm pull-left"></button>-->
                <button @click="store" class="panelSubmit btn btn-success btn-sm pull-right">
                    <i class="icon icon-save"></i> Save
                </button>
            </div>
        </div>

        <div v-if="invoices.length">
            <h3 class="form-heading">{{ trans('Invoices') }}</h3>
            <!-- Invoice Buttons -->
            <ul class="list-group">
                <li v-for="invoice in invoices" class="list-group-item">
                    <a :href="'/invoice/' + invoice.public_id + '/minor-edit'" class="loadPanel" onclick="loadPanel(event)">
                        <h4 class="list-group-item-heading"><strong>{{ invoice.name }}</strong></h4>
                    </a>
                </li>
            </ul>
        </div>

    </div>
</template>

<script>
    export default {
        props: {
            name: { default: '' },
            value: { default: '' }
        },
        data() {
            return {
                unique: '',
                processing: 0,
                timeout: false,
                query: false,
                invoices: [],
                model: {
                    registrar_id: '0',
                    errorName: 'domainCreate',
                    public_id: '0',
                    company: {},
                    address: '',
                    tld: 'com.au',
                    domainpw: '',
                    main_records: false
                },
            }
        },
        created() {
            if (this.value !== '') {
                this.model = this.value;
            }
            this.$eventHub.$on('domainSubmit', this.store);
            this.$eventHub.$on('setDomain', this.setDomain);
        },
        watch: {
            'model.address': function (val) {
                this.reset();
                this.timeoutAvailable();
            },
            'model.tld': function (val) {
                this.reset();
                this.timeoutAvailable();
            },
            model: {
                handler: function (val, oldVal) {
                    if (this.value !== '') {
                        this.$emit('input', this.model);
                    }
                },
                deep: true
            }
        },
        methods: {
            store() {
                this.$store('/api/domain/store', this);
            },
            getInvoices()
            {
                if (!this.model.public_id) {
                    return;
                }
                // == Do Post == //
                this.axios.post('/api/domain/invoices', { id: this.model.public_id })
                    .then((response) => {
                        this.invoices = response.data['invoices'];
                });
            },
            checkDomain: function () {
                this.whois = false;
                // == Get Details == //
                let domainInfo = $('#right-content .domain-info');
//                this.$root.toggleLoader(true);

                // == Clear everything == //
                $('#localRegister, #transferDomain').addClass('hide');
                domainInfo.html('');
                this.error = '';

                // == Do Post == //
                this.axios.post('/api/domain/details', {
                    registrar_id: this.model.registrar_id,
                    domain: this.model.address,
                    tld: this.model.tld
                }).then((response) => {
//                    this.$root.toggleLoader(false);
                    if (typeof response.data['success'] !== 'undefined' && response.data['success']) {
                        
                        this.query = 'hosted_' + response.data['registrar'];
                        domainInfo.hide();
                        domainInfo.html("Domain info here");
                        return;
                    } else if (typeof response.data['error'] !== 'undefined') {
                        this.error = response.data.error;
                    }
                    this.query = 'error';
                }).catch((error) => {
                    fyi(error);
                    this.error = 'An undefined error occured';
                });
            },
            reset() {
                clearTimeout(this.timeout);
                this.timeout = false;
                this.query = false;
                this.processing = false;
            },
            timeoutAvailable() {
                if (this.timeout) {
                    this.reset();
                }
                let unique = this.uniqueid();
                this.unique = unique;
                this.timeout = setTimeout(() => {
                    this.available(unique);
                }, 500);
            },
            available(unique) {
                if (this.model.address === '' || this.model.registrar_id === '0') {
                    this.reset();
                    return;
                }
                this.processing = true;
                this.axios.post('/api/domain/check', {
                    domain: this.model.address,
                    tld: this.model.tld,
                    registrar_id: this.model.registrar_id
                }).then((response) => {
                    if (this.checkUnique(unique)) return;
                    this.reset();
                    let data = response.data;
                    if (typeof data['success'] !== 'undefined' && data.success) {
                        this.query = 'success';
                    } else if (typeof data['error'] !== 'undefined' && data.error) {
                        this.query = 'registered';
                        this.checkDomain();
                    } else {
                        fyi(data);
                        fyi('Something else got returned from the check');
                    }
//                    this.query = response.data;
                }).catch((errors) => {
                    if (unique !== this.unique) return;
                    this.reset();
                    this.query = {
                        error: 'There was an unspecified error with your request'
                    };

                    /*if (typeof errors.response['data'] !== 'undefined') {

                    }*/
                });
            },
            checkUnique(unique) {
                return (unique !== this.unique);
            },
            setDomain(data) {
                this.whois = false;
                this.action = '';
                $('#right-content .domain-info').html('');
                // console.log('todo:');
                // console.log(data);
                // console.log(this.model);
                this.model = this.$setData(data, this.model);
                this.$nextTick(function () { // Runs after content is updated
                    this.timeoutAvailable();
                    this.getInvoices();
                });
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('domainSubmit', this.store);
            this.$eventHub.$off('setDomain', this.setDomain);
        },
        components: {
            'domain-fields': require('./domain-fields.vue').default,
            'registrar': require('./registrar-list.vue').default,
            'domain-registration': require('./domain-register.vue').default,
            'whois': require('./whois.vue').default
        }
    }
</script>